import React from 'react';

import {
	Container, DataService, OwnershipRequirementType, i18n,
} from '../../../../../../symphony';
import { SlActions } from '../../../../services/ActionsService/sl-actions';
import { SlDataService } from '../../../../services/sl-data.service';
import { Widget } from '../../../Widget/Widget';
import { SlLEContext } from '../../../../global-constants';
import {
	ActionType,
	IMaterialProps,
	IWidgetData,
	RequestType,
} from '../../../../global-interface';
import { useContainerData } from '../../../../../../shared/public/SlHooks/useContainerData';
import { MaterialType } from '../../../../../../api/private/learn-engine-api/learn-engine-api.interface';

export function LessonWidget({ materialInfo }: IMaterialProps): JSX.Element {
	const {
		header: {
			title, description, typeId, id, materialRelationId,
		},
		status,
		options,
	} = materialInfo;

	const { learningExperience$: learningExperience } = useContainerData(
		'global',
		DataService,
		['learningExperience$'],
	);

	const { currentItems$: currentItems } = useContainerData(
		SlLEContext,
		SlDataService,
		['currentItems$'],
	);

	const isCurrent = currentItems.some(({ materialId }) => materialId === materialRelationId);

	const { actions$ } = Container.take(SlLEContext, SlActions);

	const onClick = (): void => {
		actions$.next({
			type: ActionType.OnLessonClick,
			requestType: RequestType.Parallel,
			data: {
				materialInfo
			},
		});
	};

	const button: {
		title: string;
		paid?: boolean;
		onClick: () => void;
	} = {
		title: typeId === MaterialType.ModuleQuiz
			? i18n.t('web-le.quiz-start-button')
			: i18n.t('web-le.lesson-start-button'),
		onClick,
	};

	// if (
	// 	learningExperience.ownership.ownershipRequirementsTypeId === OwnershipRequirementType.Paid
	// 	&& !learningExperience.ownership.isOwned
	// 	&& status?.ownership?.ownershipRequirementsTypeId === OwnershipRequirementType.Paid
	// 	&& !status?.ownership?.isOwned
	// ) {
	// 	button.title = i18n.t('course.buy_course_cta');
	// 	button.paid = true;
	// }

	const widgetData: IWidgetData = {
		status,
		title,
		description,
		type: typeId,
		xp: options.xp,
		button,
		isCurrent,
		courseOwnership: learningExperience.ownership,
	};

	return (
		<div
			className="le-widget-wrapper__widget"
			le-data-id={materialRelationId}
		>
			<Widget
				parentType={options.parentType}
				widget={widgetData}
				onClick={onClick}
				id={id}
			/>
		</div>
	);
}
